import { FcRules } from "react-icons/fc";

const PolicyIcon = (): JSX.Element => {

    return (
        <FcRules 
            size="1.3rem"
            color="#99B2C6"
            style={{
                marginRight: "3px"
            }}
        />
    );

}

export default PolicyIcon;


